import { addOrUpdateTier } from './helpers'
import { TierAction } from './actions'
import { TierList } from './types'

export interface State {
  tiers?: TierList[]
  pending: boolean
  error: boolean
  editable: boolean
}

export const initialState: State = {
  tiers: undefined,
  pending: true,
  error: false,
  editable: true
}

export default (state = initialState, action: TierAction): State => {
  switch (action.type) {
    case 'tiers.fetch':
      return {
        ...state,
        pending: true,
        tiers: undefined,
        error: false,
        editable: action.payload
      }
    case 'tiers.fetchFail':
      return {
        ...state,
        pending: false,
        error: true
      }

    case 'tiers.addTiers':
      let items: TierList[] = []

      if ('payload' in action) {
        items = action.payload ?? []
      }

      if (!state.tiers) {
        return {
          ...state,
          tiers: items
        }
      }

      return {
        ...state,
        tiers: addOrUpdateTier(state.tiers, items)
      }

    default:
      return state
  }
}
